<template>
  <div id="photos">
    <headNav :routeAddress="address">
      <div slot="headNavText">{{$t('message.basc_info')}}</div>
    </headNav>
    <div class="container">
      <div class="bascInfoBox">
        <div>
          <div class="circle circle1">01</div>
          <div class="circle"></div>
          <div class="circle"></div>
          <div class="circle"></div>
        </div>
        <div class="scsf">
          <!--人脸识别-->
          <div>Nhận diện khuôn mặt</div>
<!--          请完成人脸识别,证明是本人借款。-->
          <div>Vui lòng hoàn thành nhận dạng khuôn mặt để chứng minh bạn là người vay</div>
        </div>
        <div class="bascInfoContent">
          <div style="text-align: center;padding-top: 1rem">
            <img :src="faceImg" alt="" style="width: 4rem;height: 4rem">
            <!--请手持身份证拍摄-->
            <div style="padding-top: 0.3rem;color: #f51313">( Ảnh chân dung cầm CCCD )</div>
          </div>
          <div class="intro">
<!--            拍摄须知-->
            <h3>Hướng dẫn chụp ảnh</h3>
            <div class="yt_area">
              <div class="yt_area_item">
                <img src="../../../assets/images/index/face1.png" alt="">
<!--                不佩戴眼镜-->
                <p>Không đeo kính</p>
              </div>
              <div class="yt_area_item">
                <img src="../../../assets/images/index/face2.png" alt="">
<!--                不遮挡面部-->
                <p>Không che mặt</p>
              </div>
              <div class="yt_area_item">
                <img src="../../../assets/images/index/face3.png" alt="">
<!--                不仰头拍摄-->
                <p>Không ngửa mặt</p>
              </div>
            </div>
          </div>
<!--          开始拍摄-->
          <van-uploader :max-count="1" :after-read="compressImgholdZM" class="scsfz" capture="user" v-if="!hasUpload">
            <van-button type="primary" size="normal" round class="btns" block :loading="uploading" loading-text="Loading..."> Bắt đầu chụp</van-button>
          </van-uploader>
          <van-button type="primary" size="normal" round @click="nextStep" class="btns" block v-if="hasUpload"> {{$t('message.yys_sub')}}</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import headNav from "../../HeadNav/headNav";
  import {hongkPostImg, idcard_verify} from '../../../ports/port'
  import {postAli} from '../../../ports/port'
  import {isPhotosAll} from '../../../ports/port'
  import {postUserInfo, sassSearchPhoto} from '../../../ports/port'
  import $ from 'jquery'
  import * as imageConversion from "image-conversion";
  import faceImg from '../../../assets/images/index/face.png'

  export default {
    name: "photos",
    data() {
      return {
        address:'/photos',
        HoldIDcardZM: [],//手持身份证正码
        HoldIDcardZMUrl: '',
        hasUpload:false,
        tk: JSON.parse(localStorage.getItem("tokenAll")),
        faceImg:faceImg,
        uploading:false
      }
    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
    },
    components: {
      headNav
    },
    methods: {
      getImageBase64(blob) {
        return new Promise((resolve,reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          let width;
          let height;
          reader.onload = (e) => {
            const base64 = reader.result;
            resolve(base64);
          };
          reader.onerror = error => reject(error);
        });
      },
      getImageWidthHeight(blob) {
        return new Promise((resolve,reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          let width;
          let height;
          reader.onload = (e) => {
            const img = new Image();
            img.src = e.target.result;
            img.onload = function() {
              width = this.width;
              height = this.height;
              resolve({'width':width,'height':height});
            };
          };
          reader.onerror = error => reject(error);
        });
      },
      compressImgholdZM(file) {
        // 此时可以自行将文件上传至服务器
        this.uploading = true;
        if (file) {
          let _this = this;
          let imageWidth;
          let imageHeight;
          this.getImageWidthHeight(file.file).then(res=> {
            if (res.width > res.height) {
              imageWidth = 600;
              imageHeight = parseInt((600 * res.height) / res.width);
            } else {
              imageHeight = 600;
              imageWidth = parseInt((600 * res.width) / res.height);
            }
            imageConversion.compressAccurately(file.file,{accuracy: 0.99,size:250,width:imageWidth,height:imageHeight}).then(res=>{
              //The res in the promise is a compressed Blob type (which can be treated as a File type) file;
              this.getImageBase64(res).then((base64)=>{
                hongkPostImg({userid: _this.tk.userid, img: base64, imgname: 'img3'})
                  .then(res => {
                    if (res.data.code == 200) {
                      _this.HoldIDcardZMUrl = res.data.data.url;
                      _this.faceImg = res.data.data.url;
                      // file.status = 'done';
                      this.hasUpload = true;
                      _this.$notify({type: 'success', message: res.data.msg});//图片上传不成功，请重新上传
                    } else {
                      _this.$notify({type: 'danger', message: res.data.msg});//图片上传不成功，请重新上传
                      // file.status = 'failed';
                      file.message = _this.$t('message.upload_scz_error');
                    }
                    this.uploading = false;
                  })
                  .catch(res=>{
                    this.$toast({duration:2000,message:'Network Error'})
                  })
              })
            });
          });
        }
      },
      nextStep(){
        const data = {
          userid: this.tk.userid,
          img1: sessionStorage.getItem('imgUrl1'),
          img2: sessionStorage.getItem('imgUrl2'),
          img3: this.HoldIDcardZMUrl,
          employment_Pass: ''
        };
        this.$store.commit('edit',true);//打开全局的loading
        postAli(data)
          .then(res => {
            this.$store.commit('edit',false);//关闭全局的loading
            if (res.data.code == 200) {
              isPhotosAll({userid: this.tk.userid})
                .then(res => {
                  let i = 0;
                  let _this = this;
                  if (res.data.code == 200) {
                    for (let a in res.data.data) {
                      if (res.data.data[a] == 1 && a == "img1" || a == "img2" || a == "img3") {
                        i++;
                      }
                    }
                    if (i == 3) {
                      this.$notify({type: 'success', message: this.$t('message.img_upload_success')});
                      sessionStorage.removeItem("imgUrl1");
                      sessionStorage.removeItem("imgUrl2");
                      this.$router.push({path: '/bascInfo'});
                    } else {
                      this.$notify({
                        type: 'danger',
                        message: this.$t('message.upLoad_image_no')
                      });
                    }

                  } else {
                    this.$notify({
                      type: 'danger',
                      message: this.$t('message.Parameter_error')
                    });
                  }

                })
            } else {
              this.$notify({
                type: 'danger',
                message: this.$t('message.Parameter_error')
              });
            }
          })
      }
    }
  }
</script>

<style scoped lang="scss">
  .container{
    padding: 1.6rem 15px 0;
    .circle{
      width: 0.19rem;
      height: 0.19rem;
      background-color: #D5D5D5;
      border-radius: 0.19rem;
      display: inline-block;
      margin-right: 5px;
    }
    .circle1{
      width: 0.53rem;
      height: 0.53rem;
      background: $color;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      line-height: 0.53rem;
    }
    .scsf{
      & :nth-child(1){
        font-size: 0.53rem;
        font-weight: 600;
        color: $color;
        margin: 0.36rem 0 0.3rem;
      }
      & :nth-child(2){
        font-size: 0.37rem;
        font-weight: 300;
        color: #878686;
      }
    }
    .bascInfoContent{
      .photo_border{
        background-color: #F4F8FE;
        border-radius: 5px;
        position: relative;
        overflow: hidden;
        height:4.15rem;
        width: 100%;
        text-align: center;
        padding-top: 0.5rem;
        box-sizing: border-box;
        .text{
          position: absolute;
          width: 100%;
          text-align: center;
          padding: 10px 0;
          color: #fff;
          background-color: $color;
          bottom: 0;
          left: 0;
        }
        img{
          width: 3.48rem;
        }
      }
      .intro{
        h3{
          font-size: 0.43rem;
          font-weight: 600;
          color:#333333;
          margin-top: 0.8rem;
          ~div{
            font-size: 0.35rem;
            color: #A3A3A3;
            span{
              color: #FF0000;
            }
          }
        }
        .yt_area{
          display: flex;
          margin-top: 0.67rem;
          .yt_area_item{
            display: flex;
            flex: 1;
            align-items: center;
            flex-direction: column;
            img{
              height: 1.45rem;
              margin-bottom: 6px;
            }
            p{
              font-size: 0.32rem;
              color:#A3A3A3 ;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
  .btns{
    @include defaultBtn
    margin: 0.75rem 0 1.12rem;
  }
  .scsfz,/deep/ .scsfz>.van-uploader__wrapper,/deep/ .scsfz>.van-uploader__wrapper>.van-uploader__input-wrapper{
    width: 100%;
    height: 100%;
  }
  .scsfz,.scsfz>.van-uploader__wrapper>.van-uploader__input-wrapper{
    height: 100%;
    width: 100%;
    position: relative;
    z-index: 95;
  }
  /deep/.scsfz .van-uploader__preview{
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/loanRecord/personInfo/face_intro.vue